export const Colors = {
  loader: '#ee3d4a',
  red: '#ee3d4a',
  blue: '#85d8ed',
  orange: '#FFCC00',
  white: '#FFF'
}
